import { Component, HostBinding, Input } from '@angular/core';

export class Box {
  constructor(public middle: string,
              public bottom: string,
              public top?: string,
              public middleColor?: string) {}
}

@Component({
  selector: 'mpro-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  host: {
    '[class.fade]': 'fade',
    '[class.selected]': 'selected'
  },
})
export class InfoBoxComponent {
  @HostBinding('style.--middleColor')
  @Input()
  public color: string = '#8AABFF';

  @Input() public left: Box;
  @Input() public middle?: Box;
  @Input() public right: Box;
  @Input() public fade: boolean = false;
  @Input() public selected: boolean = false;

}
